<app-navbar></app-navbar>
<div class="min-h-screen">
    <app-custom-form *ngIf="formData.length > 0" [requiredHtml]="requiredHtml" [country]="country"
        [totalCount]="totalCount" (formValue)="submitForm($event)" [jsonFormData]="formData"></app-custom-form>
</div>
<ng-template #successDialog>
    <h1 matDialogTitle>Success</h1>
    <div mat-dialog-content>Your Application has been submitted successfully</div>
    <mat-dialog-actions class="text-center">
        <button class="mb-3" mat-flat-button color="primary" matDialogClose="yes">Continue</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #failedDialog>
    <h1 matDialogTitle>Failed</h1>
    <div mat-dialog-content>Failed to submit your application</div>
    <mat-dialog-actions class="text-center">
        <button class="mb-3" mat-flat-button color="primary" matDialogClose="yes" (click)="goToTrack()">Try
            Again</button>
    </mat-dialog-actions>
</ng-template>
<ngx-spinner bdColor="rgba(256, 256, 256, 0.5)" size="default" color="#c71d22" type="ball-spin-fade"
    [fullScreen]="true">
    <p style="color: rgb(35, 35, 35)"> Please wait... </p>
</ngx-spinner>
<ngx-spinner name="passport" bdColor="rgba(0, 0, 0, 0.7)" size="default" color="#c71d22" type="ball-spin-fade"
    [fullScreen]="true">
    <p style="color: rgb(256, 256, 256)"> Reading your passport details. Please wait... </p>
</ngx-spinner>

<app-message></app-message>
<app-footer></app-footer>